import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import sal from "sal.js";
import PlanList from "../../Components/PlanList";
import { Helmet } from "@dr.pogodin/react-helmet";
import MinPlanPrice from "../../Components/MinPlanPrice";
import CouponScrollBar from "../../Components/CouponScrollBar";
import { ScrollToPlans } from "../../utils/ScrollToPlan";

export default function ManagedLinuxVPS() {
  const [applyPaddingClass, setApplyPaddingClass] = useState(false);
  useEffect(() => {
    document.title = "Fully Managed Linux VPS Hosting | Expert Support"; 
    sal();
  }, []);
  const handlePlanClick = () => {
    ScrollToPlans(".price-plan-section");
    };
  return (
    <>
      <Helmet>
            <title>Fully Managed Linux VPS Hosting | Expert Support</title>
            <meta name="description" content="We offer fully managed Linux VPS hosting with complete server care, SSD storage, strong security, regular updates, backups, and expert support." />
            <meta name="keywords" content="Fully Managed Linux VPS Hosting, Managed Linux VPS  , Managed Linux VPS Hosting, Linux-Managed-VPS" />
            <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/managed-linux-vps`} />
            <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/managed-linux-vps`} />
            <meta property="og:title" content="Ultra-Reliable Managed Linux VPS for Constant Website Uptime" />
            <meta property="og:description" content="Get Managed Linux VPS solutions with high reliability, and solid security-best for businesses opting constant availability, and growth-based infrastructure." />
      </Helmet>
      <div className="wordpress-hosting-banner about-banner pb-120 bg-dark">
        <div className="container">
            <div className="row g-4 align-items-center align-items-xxl-end">
                <div className="col-lg-7">
                    <div className="d-flex align-items-center gap-2">
                        <div className="w-3 h-3 rounded-circle bg-primary flex-shrink-0"></div>
                        <span className="d-block fw-semibold mb-0 text-primary">
                            Hands-Off Linux VPS
                        </span>
                    </div>
                    <h1 className="mb-6 text-white">
                        Hosting Sluggish? Nah, Not Now with Our Managed Linux VPS.
                    </h1>
                    <p className="text-white max-text-60 mb-8 text-opacity-75">
                        Tired of your site feeling like it's stuck in heavy traffic? Migrate to Managed Linux VPS and look at your performance go from 0 to hero! With high speeds and 24/7 support, you’ll never have to worry about slow loading times again.
                    </p>
                    <div className="d-flex align-items-center flex-wrap gap-4">
                        <Link to="/contact-us" className="btn btn-primary btn-arrow btn-lg fs-14 fw-semibold rounded btn-height">
                            <span className="btn-arrow__text">
                                Free Trial
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </Link>
                        <button onClick={handlePlanClick} className="btn btn-light btn-arrow btn-lg fs-14 fw-semibold rounded transition btn-height">
                            <span className="btn-arrow__text">
                                Explore
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </button>
                        <MinPlanPrice category="managed-linux-vps" />
                    </div>
                    <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
                </div>
                <div className="col-lg-5 ipad-mt">
                    <div className="about-banner__img">
                        <img src="images/hosting-sluggish-nah.webp" alt="image" className="img-fluid full-width-img" />
                    </div>
                </div>
            </div>
        </div>
      </div>
      <section className="bg-white pt-120 pb-100">
        <div className="container">
            <div className="row align-items-center justify-content-between g-4">
                <div className="col-xl-6 col-lg-10">
                  <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Remain Stress-Free</small>
                    <h2 className="mb-0 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Leave the Tech Drama: Fully Managed VPS, No Sweat, Just Relax</h2>
                </div>
            </div>
            <div className="mt-8">
                <div className="row g-4">
                    <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="ssl-benefit-item px-5 py-7 little-dark-border hover-shadow transition rounded-3 h-100">
                            <img src="images/speed-that-hits.webp" alt="icon" className="img-fluid mb-4" />
                            <h6 className="mb-2">Speed That Hits Different</h6>
                            <p className="mb-0">No lag-get blazing-fast speed with our SSD-based VPS. Quick, smooth, and ready to roll.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="ssl-benefit-item px-5 py-7 little-dark-border hover-shadow transition rounded-3 h-100">
                            <img src="images/own-it-like.webp" alt="icon" className="img-fluid mb-4" />
                            <h6 className="mb-2">Own It Like a Boss</h6>
                            <p className="mb-0">Take charge with full access & dedicated IPs for all your VMs. No restrictions, just endless control.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                        <div className="ssl-benefit-item px-5 py-7 little-dark-border hover-shadow transition rounded-3 h-100">
                            <img src="images/oops!-proof.webp" alt="icon" className="img-fluid mb-4" />
                            <h6 className="mb-2">Oops! Proof Your Data</h6>
                            <p className="mb-0">Lag happens, but your behind-the-scenes hero is always there. Free backups to keep your files safe.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="600" data-sal-easing="ease-in-out-sine">
                        <div className="ssl-benefit-item px-5 py-7 little-dark-border hover-shadow transition rounded-3 h-100">
                            <img src="images/switching-made.webp" alt="icon" className="img-fluid mb-4" />
                            <h6 className="mb-2">Switching Made Easy</h6>
                            <p className="mb-0">No downtime, no drama we migrate your website for free. Just sit back and see the magic.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="700" data-sal-easing="ease-in-out-sine">
                        <div className="ssl-benefit-item px-5 py-7 little-dark-border hover-shadow transition rounded-3 h-100">
                            <img src="images/pick-your.webp" alt="icon" className="img-fluid mb-4" />
                            <h6 className="mb-2">Pick Your Vibe</h6>
                            <p className="mb-0">Tired of the same setup? Choose what feels right - Ubuntu, CentOS, Debian, switch today.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="800" data-sal-easing="ease-in-out-sine">
                        <div className="ssl-benefit-item px-5 py-7 little-dark-border hover-shadow transition rounded-3 h-100">
                            <img src="images/run-it-your.webp" alt="icon" className="img-fluid mb-4" />
                            <h6 className="mb-2">Run It Your Way</h6>
                            <p className="mb-0">Tired of slow dashboards? Slide into Plesk, CWP, Virtualmin, or cPanel choose what vibes with you.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>
      <section className="price-plan-section pt-100 pb-100">
        <CouponScrollBar setPaddingClass={setApplyPaddingClass} />
        <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-8">
                        <div className="text-center">
                            <span className="section-title-dark style-bg fadeInUp">Our Plans</span>
                            <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine"> Go From Frustration to Flawless-Plans That Scale</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <PlanList category={'managed-linux-vps'}/>
          
      </section>
      <section className="pt-100 pb-60">
        <div className="container">
            <div className="row align-items-center g-4">
                <div className="col-lg-6">
                    <div className="d-inline-flex align-items-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="px-3 py-1 border border-primary rounded d-inline-flex align-items-center gap-2"><div className="w-2 h-2 rounded-circle bg-primary"></div><small className="text-primary fw-bold">Built to Run Things Smoothly</small></div>
                    </div>
                    <h2 className="mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Virtualization Vibes Only</h2>
                    <p className="mb-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Fed up with applications crashing or all things moving slowly? With our Managed Linux VPS Hosting, you experience a top-notch setup that just works for you. <br/>

                        With a balanced vibe powered by experts, you stay in complete control. And hey, if it’s not your type? There’s also a money-back option. Seamless. Secure. Stress-free.</p>
                    <Link to="/contact-us" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded sal-animate btn-height" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine"><span className="btn-arrow__text">Contact Sales<span className="btn-arrow__icon"><i className="fa-solid fa-arrow-right"></i></span></span></Link>
                </div>
                <div className="col-lg-6 ipad-mt">
                    <img src="images/virtualization-vibes.webp" alt="image" className="img-fluid sal-animate full-width-img" data-sal="fade" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" />
                </div>
            </div>
        </div>
      </section>
      <div className="container pt-40">
        <div className="row">
            <div className="col-12">
                <div className="bg-dark pt-80 pb-80 px-5 px-md-8 px-xl-12 rounded-4 position-relative z-1 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="row g-4 align-items-center">
                        <div className="col-md-10 col-lg-10 col-xl-5">
                            <h2 className="text-white">
                                Stop Settling for Less with Managed VPS Hosting!
                            </h2>
                            <p className="mb-8 text-white text-opacity-75">
                                Why stick to general when you can have our Managed Linux VPS that gives you full control, security, and high performance? Let us manage the tech while you focus on scaling up your business seamlessly.
                            </p>
                        </div>
                        <div className="col-xl-7">
                            <div className="row g-4 g-xl-0 feature-card">
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/wish-for-dedicated.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            Wish for Dedicated Speed?
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            With the help of our 100% SSD VPS, your web applications run at high speed, ensuring optimal performance every time. No lagging-just pure, high power.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/any-tech-trouble.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            Any Tech Trouble or Issue?
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            No worries! Our 24/7 expert team is always up to jump in and fix your bugs on the go. Whether it's a small issue or a major fix, we are there for you anytime you want it.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/worried-about.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            Worried About Downtime?
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            With our powerful infrastructure, your web applications will continue running seamlessly 24/7. There will be no issues or stress-just pure, constant performance.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/want-to-be-100-satisfied.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            Want to be 100% Satisfied?
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            When you’re ideally glowing, we’re happy! Your 5-star reviews keep us going, and we’re dedicated to delivering improved services daily. Your trust helps us.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/unexpected-server.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            Unexpected Server Stress?
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            Say bye to tech stress with our fully managed VPS hosting! Emphasize progressing your brand while we smoothly handle the backend behind the scenes.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/ready-for-constant.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            Ready for Constant Growth?
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            Watch your business grow as you scale your VPS with us. Scale assets resources on time to meet your business needs and keep things running smoothly!
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img src="images/vps-feature-shape.png" alt="image" className="img-fluid d-none d-xl-block position-absolute left-0 top-0 z-n1" />
                </div>
            </div>
        </div>
      </div>
      <section className="pt-100 pb-100">
        <div className="container">
            <div className="cta-wrapper-one pt-60 pb-60 px-6 rounded-3">
                <div className="row justify-content-center">
                    <div className="col-xxl-7 col-xl-9">
                        <div className="d-flex justify-content-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                            <div className="px-3 py-1 border border-primary rounded d-inline-flex align-items-center gap-2">
                                <div className="w-2 h-2 rounded-circle bg-primary"></div>
                                <small className="text-primary fw-bold">You + Us = Hosting Goals</small>
                            </div>
                        </div>
                        <div className="text-center mt-5">
                            <h2 className="mb-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Big Goals?</h2>
                            <p className="mb-8 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Go Online with India’s #1 Managed Linux VPS Hosting</p>
                        </div>
                        <div className="d-flex align-items-center justify-content-center gap-4 flex-wrap flex-md-nowrap sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                            <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                            <span className="btn-arrow__text">
                                Start Now
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                           </button>
                            <Link to="/frequently-asked-questions" className="btn btn-dark btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                                <span className="btn-arrow__text">
                                    Learn More
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>
    </>
  );
}
